<div class="d-flex" [ngClass]="{ 'reverted' : reverted}">
  <div class="single-preference switch-hover" [ngClass]="{ 'disabled' : disabled, 'large': large }">
    <div class="setting-switch" (click)="switchSetting(settingName ?? '')" [ngClass]="{ 'switch-active' : statusSetting && !disabled }">
      <div class="moving-part" [ngClass]="{ 'switch_active_position' : statusSetting }"></div>
    </div>
    <div class="setting-name" (click)="switchSetting(settingName ?? '')">
      <h3 [style.fontSize.px]="fontSize" [ngClass]="{'truncated-text' : textEllipsis }">
        {{ nameTranslationKey ? (('view_translations.' + nameTranslationKey) | translate) : inputName }}
      </h3>
    </div>
  </div>
  <div
    class="tooltip-button tool-tip"
    ngbTooltip="{{ ('view_translations.' + tooltipText) | translate }}"
    container="body"
    placement="top-right"
    tooltipClass="my-configurations-tooltip"
    *ngIf="tooltipText">
    <nb-icon icon="info" pack="icomoon"></nb-icon>
  </div>
</div>
